import CryptoJS from 'crypto-js';

// AES 加密方法，用于前端对数据进行加密
export const aesEncrypt = (plainText) => {
  // 后端使用的密钥，必须保持一致
  const RANDOM = "2024102900100101"; // 密钥应与后端一致
  try {
    // 将密钥转换为 CryptoJS 格式
    const key = CryptoJS.enc.Utf8.parse(RANDOM);

    // 将明文转换为 CryptoJS 格式
    const plainTextUtf8 = CryptoJS.enc.Utf8.parse(plainText);

    // 使用 AES 加密
    const encrypted = CryptoJS.AES.encrypt(plainTextUtf8, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    // 转换加密后的数据为 Base64 格式字符串
    const encryptedBase64 = encrypted.toString();
    // 替换 + 为 %2B
    // const encryptedBase2B = encryptedBase64.replace(/\+/g, '%2B') 
    

    return encodeURIComponent(encryptedBase64);
  } catch (e) {
    console.error("加密失败", e);
    return null;
  }
}

// 前端公共方法，用于解密后端返回的 AES 加密数据
export const aesDecrypt = (encryptedData) => {
  // 后端使用的密钥，必须保持一致
  const RANDOM = "2024102900100101"; // 密钥应与后端一致
  try {
    // 将密钥转换为 CryptoJS 格式
    const key = CryptoJS.enc.Utf8.parse(RANDOM);
    
    // Base64 解码密文
    const encryptedBase64 = CryptoJS.enc.Base64.parse(encryptedData);
    const encryptedHexStr = encryptedBase64.toString(CryptoJS.enc.Hex);
    const encryptedBytes = CryptoJS.enc.Hex.parse(encryptedHexStr);

    // 使用 AES 解密
    const decrypted = CryptoJS.AES.decrypt({
        ciphertext: encryptedBytes
    }, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });

    // 转换解密后的数据为字符串格式
    const plaintext = decrypted.toString(CryptoJS.enc.Utf8);
    return plaintext;
  } catch (e) {
      console.error("解密失败", e);
      return null;
  }
}

